import { useState, useEffect } from 'react';
import { customFetch } from '../../hooks/customFetch';
import { LeaderboardPeriod, LeaderboardEntry } from './LeaderboardTypes';

interface UseLeaderboardDataReturn {
  leaderboardData: LeaderboardEntry[];
  isLoading: boolean;
  error: string | null;
}

const useLeaderboardData = (period: LeaderboardPeriod): UseLeaderboardDataReturn => {
  const [leaderboardData, setLeaderboardData] = useState<LeaderboardEntry[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchLeaderboardData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const data = await customFetch('getLeaderboardData', { period });
        
        if (data && Array.isArray(data)) {
          // Ensure data is properly sorted by score
          const sortedData = [...data].sort((a, b) => b.score - a.score);
          setLeaderboardData(sortedData);
        } else {
          setError('Failed to fetch leaderboard data');
        }
      } catch (err) {
        setError('An error occurred while fetching leaderboard data');
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchLeaderboardData();
  }, [period]);

  return { leaderboardData, isLoading, error };
};

export default useLeaderboardData; 